// @ts-ignore
import contextSchema from './context.graphql';
import { editorSchema } from './editor';
import { notificationSchema } from './notification';
import { dialogSchema } from './dialog';
import { statusbarSchema } from './statusbar';
import { contextMenuSchema } from './contextmenu';
import { quickInputModelSchema } from './quickInputModel';
import { keybindingsSchema, keybindingsInputSchema } from './keybindings';
import { gotoLineQuickAccessSchema } from './gotoLineQuickAccess';

const schema = [
    editorSchema,
    notificationSchema,
    contextSchema,
    dialogSchema,
    statusbarSchema,
    contextMenuSchema,
    quickInputModelSchema,
    keybindingsSchema,
    keybindingsInputSchema,
    gotoLineQuickAccessSchema,
].join('\n');

export { editorSchema, notificationSchema, schema };

